import { UpdatePasswordCriteria } from "./auth";
import { BaseMemberSession } from "./member";
export class ResetPasswordRequestPayload {
    enrollmentUID: string;
    companyCode: string;
    systemNumber?: number;
    reCaptchaID?: number;
    reCaptchaToken?: string;
    isPortal: boolean;
    isSelectMember?: boolean;

    constructor() {
        this.enrollmentUID = null;
        this.companyCode = null;
        this.systemNumber = 0;
        this.reCaptchaID = null;
        this.reCaptchaToken = null;
        this.isPortal = true;
        this.isSelectMember;
    }
}

export class BaseMemberSessionList {
    members: BaseMemberSession[];

    constructor() {
        this.members = null;
    }
}
export class ResetPasswordRequestResponse extends BaseMemberSessionList {
    messageForDisplay: string;

    constructor() {
        super();
        this.messageForDisplay = null;
    }
}

export class AgentCreatePassword extends UpdatePasswordCriteria {
    adminDirectSystem: string;
    agentCity: string;
    agentState: string;

    constructor() {
        super();
        this.adminDirectSystem = null;
        this.agentCity = null;
        this.agentState = null;
    }
}